/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconAd2 = createReactComponent("ad-2", "IconAd2", [
  ["path", { d: "M11.933 5h-6.933v16h13v-8", key: "svg-0" }],
  ["path", { d: "M14 17h-5", key: "svg-1" }],
  ["path", { d: "M9 13h5v-4h-5z", key: "svg-2" }],
  ["path", { d: "M15 5v-2", key: "svg-3" }],
  ["path", { d: "M18 6l2 -2", key: "svg-4" }],
  ["path", { d: "M19 9h2", key: "svg-5" }]
]);

export { IconAd2 as default };
//# sourceMappingURL=IconAd2.js.map
